import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AreaChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"area_chart"}/>
}
